import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {registration, registrations} = api



/**
 * 查找报名记录
 */
export async function findRegistration(params) {
    return request({url: registration, method: 'get', data: params,})
}

/**
 * 创建报名记录
 */
export async function createRegistration(params) {
    return request({url: registrations, method: 'post', data: params,})
}

/**
 * 更新报名记录
 */
export async function updateRegistration(params) {
    return request({url: registration, method: 'put', data: params,})
}

/**
 * 删除报名记录
 */
export async function deleteRegistration(params) {
    return request({url: registration, method: 'delete', data: params,})
}


/**
 * 查找报名记录列表
 */
export async function findRegistrations(params) {
    return request({url: registrations, method: 'get', data: params,})
}

/**
 * 删除报名记录
 */
export async function deleteRegistrations(params) {
    return request({url: registrations, method: 'delete', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/registration.js